import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, AfterViewInit, ChangeDetectorRef, Optional, LOCALE_ID, Inject } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { MessagerService } from '@farris/ui-messager';
import { Observable, of } from 'rxjs';
import { PickedResult, LookupGridComponent } from '@farris/ui-lookup';
import { ResubmitEffect } from './backward-rule.entity';
import { NotifyService } from '@farris/ui-notify';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'procDesigner-backward-rule',
  templateUrl: './backward-rule.component.html',
  styleUrls: ['./backward-rule.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class BackwardRuleComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  @Input() editorParams: any = {};
  @Input()
  set value(data: any) {
    if (data) {
      this.selectAbleChecked = data.SelectTargetAble;
      if(!data.SelectTargetAble) {
        this.selectTargetList = new Array<string>();
      }else {
        this.selectTargetList = data.SelectTargetList;
      }
      this.waitReturnChecked = data.WaitReturn;
      this.dynamicBackWardRuleAbleChecked = data.DynamicBackWardRuleAble;
      this.resubmitEffect = data.ResubmitEffect;
      if (!data.TargetRef) {
        this.targetRef = 'Empty';
      } else {
        this.targetRef = data.TargetRef;
      }
      if (this.resubmitEffect === null) {
        this.resubmitEffect = ResubmitEffect.sequence;
      }
      const strs: string[] = data.SelectTargetList;
      if (strs && strs.length > 0) {
        for (const str of strs) {
          if(this.listItems.filter(act => act.Id === str)[0]) {
            const name = this.listItems.filter(act => act.Id === str)[0].Name;
            if(this.displayBackScopeText){
              this.displayBackScopeText = this.displayBackScopeText.concat(',' + name);
            }else {
              this.displayBackScopeText = name;
            }
          }
          // const acti = { Id: str, Name: name };
        }
      }
      const act = this.listItems.find(item => item.Id === this.targetRef);
      if (act) {
        this.displayText = act.Name;
      } else {
        this.displayText = '';
        setTimeout(() => {
          this.message.warning(this.localePipe.transform('component.backwardRule.reEdit'));
        }, 500);
      }
    }
  }
  @Input() nodeType: 'UserActivity' | 'CallActivitySubProcess' = 'UserActivity';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('hlp') hlp: LookupGridComponent;
  @ViewChild('hlpScope') hlpScope: LookupGridComponent;
  modalConfig = {
    title: this.localePipe.transform('component.backwardRule.backwardRule'),
    width: 760,
    height: 505,
    showButtons: true
  };
  displayText: string;
  displayBackScopeText: string;
  fullActs = [];
  listItems = [
    { Id: 'InitialActityId', Name: this.localePipe.transform('component.backwardRule.initialActityId') },
    { Id: 'PrecursorActivityId', Name: this.localePipe.transform('component.backwardRule.precursorActivityId') },
    { Id: 'Empty', Name: this.localePipe.transform('component.backwardRule.empty') }
  ];

  items = [];
  itemsTemp = [];
  itemsBackScope = [];
  itemsBackScopeTemp = [];

  columns = [
    { title: this.localePipe.transform('component.backwardRule.name'), field: 'Name', width: 100, searchField: 'Name' },
    { title: this.localePipe.transform('component.backwardRule.id'), field: 'Id', width: 100, searchField: 'Id' },
  ];
  selectAbleChecked = false;
  waitReturnChecked = false;
  resubmitEffect: ResubmitEffect;
  resubmitEffectOptions = [
    { value: ResubmitEffect.sequence, text: this.localePipe.transform('component.backwardRule.sequence') },
    { value: ResubmitEffect.backToMe, text: this.localePipe.transform('component.backwardRule.backToMe') },
    { value: ResubmitEffect.backToCurrentNode, text: this.localePipe.transform('component.backwardRule.backToCurrentNode') },
  ];
  dynamicBackWardRuleAbleChecked = false;
  targetRef = this.listItems[0].Id;
  selectTargetList = new Array<string>();
  popover = '1.顺序流转:按照流转线顺序进行流转; 2.返回我:完成策略为抢占：只给驳回人创建任务,完成策略为会签：驳回人与未审批人收到新任务，已审批人员自动审批通过; 3.返回本节点:实际效果受“再次进入节点时，办理人是否是节点已办人员影响”选项的影响';
  pageInfo = {
    pageIndex: 1,
    pageList: [10, 20, 30, 50],
    pageSize: 20
  };

  total: number;
  totalBackScope: number;

  constructor(
    private uiState: ProcessDesignerUIState,
    private message: MessagerService,
    private notify: NotifyService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    if(this.uiState.userActList) {
      this.uiState.userActList.forEach(u => {
        this.listItems = this.listItems.concat({
          Id: u.Id,
          Name: u.Name
        })
      });
    };
    this.items = this.listItems;
    this.itemsBackScope = this.listItems;
    this.total = this.listItems.length;
    this.totalBackScope = this.listItems.length;
    }

  ngOnInit() {
    this.nodeType = this.editorParams.nodeType;
    if (this.nodeType !== 'UserActivity') {
      this.listItems = this.listItems.filter(i => i.Id !== 'Empty');
      this.items = this.listItems;
      this.total = this.listItems.length;
    }
    this.itemsBackScope = this.listItems.filter(i => i.Id !== 'Empty' && i.Id !== 'PrecursorActivityId');
    this.totalBackScope = this.itemsBackScope.length;
    this.itemsTemp = this.deepCloneDefine(this.items);
    this.itemsBackScopeTemp = this.deepCloneDefine(this.itemsBackScope);

  }

  ngAfterViewInit() {
  }

  selectAbleClick() {
    if (this.uiState.propertyData.ClrTypeID === 'wf.UserActivity'
      && this.uiState.propertyData.CompleteStrategy !== this.uiState.completeIterator[0].key
      && this.selectAbleChecked === true) {
      this.message.info(this.localePipe.transform('component.backwardRule.selectAbleClick'), () => {
        this.selectAbleChecked = false;
      });
    }
    if(this.selectAbleChecked == false) {
      // this.displayTestText = '';
    }
  }
  waitReturnClick() {
    this.waitReturnChecked = !this.waitReturnChecked;
  }
  dynamicBackWardRuleAbleClick() {
    if(this.uiState.propertyData.ClrTypeID === 'wf.UserActivity'
      && this.uiState.propertyData.MultiInstanceLoopCharacteristics
      && this.uiState.propertyData.MultiInstanceLoopCharacteristics.enable
      && this.dynamicBackWardRuleAbleChecked
    ) {
      this.message.info(this.localePipe.transform('component.backwardRule.dynamicBackWardRuleAbleClick'), () => {
        this.dynamicBackWardRuleAbleChecked = false;
      })
    }
  }
  dictPicked = (arg: any): Observable<PickedResult> => {
    this.targetRef = arg.Id;
    this.displayText = arg.Name;
    if (arg.Id === 'Empty' && !this.selectAbleChecked) {
      this.selectAbleChecked = true;
      this.notify.info(this.localePipe.transform('component.backwardRule.dictPicked'));
    }
    return of({ closeDialog: true });
  }
  dictPickedBackScope = (arg: any): Observable<PickedResult> => {
    this.fullActs = arg;
    return of({ closeDialog: true });
  }

  beforeOpen = (): Observable<boolean> => {
    this.items = this.deepCloneBackDefine(this.itemsTemp);
    return of(true);
  }

  beforeOpenBackScope = (): Observable<boolean> => {
    this.itemsBackScope = this.deepCloneBackDefine(this.itemsBackScopeTemp);
    return of(true);
  }

  resubmitEffectChange(data: any) {
    if(data && data.value) {
      if(data.value === ResubmitEffect.backToMe) {
        if(this.uiState.propertyData.ClrTypeID === 'wf.UserActivity'
          && this.uiState.propertyData.MultiInstanceLoopCharacteristics
          && this.uiState.propertyData.MultiInstanceLoopCharacteristics.enable
        ) {
          this.message.info(this.localePipe.transform('component.backwardRule.backToMeForbid'), () => {
            this.resubmitEffect = ResubmitEffect.sequence;
          })
        }
      }else {
        this.resubmitEffect = data.value;
      }
    }
  }

  onbeforeLoadData = (e) => {
    let list = [];
    if (this.fullActs.length === 0 && this.selectTargetList && this.selectTargetList.length > 0) {
        this.uiState.userActList.forEach(u => {
          if(this.selectTargetList.some(s => s === u.Id)) {
            list.push({'Id': u.Id, 'Name': u.Name});
          }
        });
        if(this.selectTargetList.some(s => s === 'InitialActityId')) {
          list.push({'Id':'InitialActityId', 'Name': this.localePipe.transform('component.backwardRule.initialActityId')});
        };
    } else if (this.fullActs && this.fullActs.length > 0) {
      // 附加节点的id传给模型上的DestinationActivities
      this.fullActs.forEach(act => {
        if(this.uiState.userActList.some(u => u.Id == act.Id)) {
          list.push({'Id':act.Id, 'Name':act.Name});
        }else if(act.Id === 'InitialActityId') {
          list.push({'Id':act.Id, 'Name': this.localePipe.transform('component.backwardRule.initialActityId')});
        }
      });
    }
    if(list && list.length > 0) {
      e.instance.selectedItems = list;
    }
    return of(this.hlpScope);
  }

  clickOK() {
    const list = [];
    if(this.selectAbleChecked) {
      let displayBackScopeTextArray = [];
      if(this.displayBackScopeText) {
        displayBackScopeTextArray = this.displayBackScopeText.split(',');
      }
      // 重新打开设置界面，没有进行节点配置的情况（DestinationActivities）
      if (this.fullActs.length === 0 && displayBackScopeTextArray && displayBackScopeTextArray.length > 0) {
        for (const act of displayBackScopeTextArray) {
          for (const allAct of this.listItems) {
            if (act === allAct.Name) {
              list.push(allAct.Id);
              break;
            }
          }
        }
      } else if (this.fullActs && this.fullActs.length > 0) {
        // 附加节点的id传给模型上的DestinationActivities
        this.fullActs.forEach(act => {
          if(this.uiState.userActList.some(u => u.Id == act.Id)) {
            list.push(act.Id)
          }else if(act.Id === 'InitialActityId') {
            list.push(act.Id);
          }
        });
      }
    }
    const backWardRule = {
      TargetRef: this.getTargetRef(),
      SelectTargetAble: this.selectAbleChecked,
      WaitReturn: this.waitReturnChecked,
      DynamicBackWardRuleAble: this.dynamicBackWardRuleAbleChecked,
      SelectTargetList: list,
      ResubmitEffect: this.resubmitEffect
    };
    const object = { value: backWardRule, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  pagerChanged(arg: any) {
    this.pageInfo.pageIndex = arg.pageIndex;
    this.pageInfo.pageSize = arg.pageSize;
    const search = {
      field: arg.searchValue.searchField,
      value: arg.searchValue.searchValue
    };
    this.load(search);
  }

  pagerChangedBackScope(arg: any) {
    this.pageInfo.pageIndex = arg.pageIndex;
    this.pageInfo.pageSize = arg.pageSize;
    const search = {
      field: arg.searchValue.searchField,
      value: arg.searchValue.searchValue
    };
    this.loadBackScope(search);
  }

  pageSizeChange(arg: any) {
    console.log(arg);
    this.pageInfo.pageIndex = arg.pageIndex;
    this.pageInfo.pageSize = arg.pageSize;
    const search = {
      field: arg.searchValue.searchField,
      value: arg.searchValue.searchValue
    };
    this.load(search);
  }

  pageSizeChangeBackScope(arg: any) {
    console.log(arg);
    this.pageInfo.pageIndex = arg.pageIndex;
    this.pageInfo.pageSize = arg.pageSize;
    const search = {
      field: arg.searchValue.searchField,
      value: arg.searchValue.searchValue
    };
    this.loadBackScope(search);
  }

  search(arg: any) {
    this.pageInfo.pageIndex = arg.pageInfo.pageIndex;
    this.pageInfo.pageSize = arg.pageInfo.pageSize;
    const search = arg.search;

    this.load(search);
  }

  searchBackScope(arg: any) {
    this.pageInfo.pageIndex = arg.pageInfo.pageIndex;
    this.pageInfo.pageSize = arg.pageInfo.pageSize;
    const search = arg.search;

    this.loadBackScope(search);
  }

  load(search?: { field: string, value: string}) {
    const start = (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize;
    const end = start + this.pageInfo.pageSize;
    let items = [];
    if (search) {
      if (search.field === '*') {
        items = this.listItems.filter(i => i.Name.indexOf(search.value) > -1 || i.Id.indexOf(search.value) > -1);
      } else {
        items = this.listItems.filter(f => f[search.field].indexOf(search.value) > -1);
      }
    } else {
      items = this.listItems;
    }
    this.total = items.length;
    this.items = items;
    this.hlp.componentRef.instance.loadData({
      data: this.items
    });
  }

  loadBackScope(search?: { field: string, value: string}) {
    const start = (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize;
    const end = start + this.pageInfo.pageSize;
    let itemsBackScope = [];
    if (search) {
      if (search.field === '*') {
        itemsBackScope = this.listItems.filter(i => i.Name.indexOf(search.value) > -1 || i.Id.indexOf(search.value) > -1);
      } else {
        itemsBackScope = this.listItems.filter(f => f[search.field].indexOf(search.value) > -1);
      }
    } else {
      itemsBackScope = this.listItems;
    }
    if(itemsBackScope && itemsBackScope.length > 0) {
      itemsBackScope = itemsBackScope.filter(i => i.Id !== 'Empty' && i.Id !== 'PrecursorActivityId');
    }
    this.totalBackScope = itemsBackScope.length;
    this.itemsBackScope = itemsBackScope;
    this.hlpScope.componentRef.instance.loadData({
      data: this.itemsBackScope
    });
  }

  private getTargetRef() {
    if (this.targetRef === 'Empty') {
      return '';
    } else {
      return this.targetRef;
    }
  }

  //为了打开后仍然显示最初数据，而不是过滤后的数据
  deepCloneDefine(target: any[]) {
    let result = [];
    target.forEach(t => result.push(JSON.stringify(t)));
    return result;
  }

  deepCloneBackDefine(target: any[]) {
    let result = [];
    target.forEach(t => result.push(JSON.parse(t)));
    return result;
  }

}
export class BackwardRuleConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data) {
      return this.localePipe.transform('component.backwardRule.set');
    }
    return this.localePipe.transform('component.backwardRule.notSet');
  }
}

